import { Injectable } from '@angular/core';
import { IMarketRate } from '@models/beta/marketrate';
import { LocalStorageKeys } from '@models/store/local-storage-keys';
import { IStoreState } from '@models/store/store-state';
import { VintageService } from '@services/decay/vintage.service';
import { AcquisitionService } from '@services/global/acquisition.service';
import { GlobalSettingsService } from '@services/global/global-settings.service';
import { ProductService } from '@services/global/product.service';
import { LocalStorageService } from '@services/local-storage.service';
import { ObservableStore } from '@services/observable-store/dist';
import { MarketRateService } from '@services/settings/market-rate.service';
import { forkJoin, Observable } from 'rxjs';

// const log = (...args) => {
//   // Set to true for debugging
//   if (false) {
//     console.log(`👨‍💻 %c [Store] ${args[0]}`, 'font-family: Helvetica; color: green; font-weight: 600;', ...args.slice(1));
//   }
// };

@Injectable({
  providedIn: 'root'
})
export class StoreService extends ObservableStore<IStoreState> {
  private readonly subs = [];

  get state() {
    return this.getState();
  }

  public getMarketRates(): Observable<IMarketRate[]> {
    return this.marketRateService.getMarketRates();
  }

  public clearBetaLocalStorage(productId: number) {
    this.localStorageService.clearFromLocalStorage(LocalStorageKeys.Beta, productId);
  }

  constructor(
    private readonly acquisitionService: AcquisitionService,
    private readonly globalSettingsService: GlobalSettingsService,
    private readonly localStorageService: LocalStorageService,
    private readonly marketRateService: MarketRateService,
    private readonly productService: ProductService,
    private readonly vintageService: VintageService
  ) {
    super({ trackStateHistory: true });

    this.productService
      .getProductGroups()
      .toPromise()
      .then(() => this.productService.getProducts().subscribe());

    this.subs.push(
      this.productService.stateChanged,
      this.vintageService.stateChanged,
      this.acquisitionService.stateChanged,
      this.globalSettingsService.stateChanged,
      this.acquisitionService.getAcquisitions()
    );

    forkJoin(this.subs).subscribe();
  }

  // private handleError(error: any) {
  //   console.error('server error:', error);
  //   if (error.error instanceof Error) {
  //     const errMessage = error.error.message;
  //     return throwError(errMessage);
  //   }
  //   return throwError(error || 'Server error');
  // }
}
